import AppContext from "PFApp/app_context";
import { useCustomValues } from "PFCore/hooks/queries/custom_values/use_custom_values";
import { useContext, useMemo } from "react";

export const useInitialValues = () => {
  const {
    store: {
      currentProfile: { preferences }
    }
  } = useContext(AppContext);

  const { data: skillsCustomValues } = useCustomValues(
    {
      ids: preferences.skills
    },
    { enabled: Boolean(preferences.skills?.length) }
  );

  return useMemo(
    () => ({
      officeWork: preferences.office_work ?? false,
      remoteWork: preferences.remote_work ?? false,
      hybridWork: preferences.hybrid_work ?? false,
      projectDurationMonths: {
        min: preferences.project_min_duration_months ?? 1,
        max: preferences.project_max_duration_months ?? 12
      },
      skills: skillsCustomValues?.entries || []
    }),
    [skillsCustomValues, preferences]
  );
};
